import { attach, createEffect, createEvent, type EffectParams, sample } from 'effector'

import type { ColorToken } from '@portal/styled-system/tokens'

import { $portalProfile, portalProfileAPI } from '@/entities/profile/portal'
import { $lang } from '@/shared/lib/i18n'
import { navigateTo } from '@/shared/lib/next'
import { type NotificationArgs, showNotificationFx } from '@/shared/ui'
import { createHideFx, modal } from '@/shared/ui/modal'

export const laterButtonClicked = createEvent()
export const changeAddressButtonClicked = createEvent()
export const verifyAddressButtonClicked = createEvent()

export const showFx = createEffect<
    {
        email: string
        title?: string
        titleIconClass?: string
        intro?: string
        headerBackgroundColor?: ColorToken
    },
    string
>()
export const hideFx = createHideFx(showFx)

const emailVerifyFx = attach({
    effect: portalProfileAPI.emailVerify,
    source: $lang,
    mapParams: (_: void, lang): EffectParams<typeof portalProfileAPI.emailVerify> => ({
        lang,
    }),
})

sample({
    clock: laterButtonClicked,
    target: hideFx,
})

sample({
    clock: changeAddressButtonClicked,
    target: [
        modal.closeAll,
        navigateTo('/account', {
            query: {
                editEmail: '1',
            },
        }),
    ],
})

sample({
    clock: verifyAddressButtonClicked,
    target: emailVerifyFx,
})

sample({
    clock: emailVerifyFx.fail,
    fn: (): NotificationArgs => ({ notification: 'error_default' }),
    target: showNotificationFx,
})

sample({
    clock: emailVerifyFx.done,
    source: $portalProfile,
    filter: Boolean,
    fn: ({ email }): NotificationArgs => ({ notification: 'email_link_sent', email }),
    target: showNotificationFx,
})

sample({
    clock: verifyAddressButtonClicked,
    target: hideFx,
})
